import React, { useEffect, useState } from "react";
import { useGeneralParams } from "../../../../hooks/useDataPaginate";
import { MinimalActionButton } from "../../../../components/form/minimalActionButton";
import { ModalForm } from "../../../../components/modals/ModalForm";
import {
  CreateClientValues,
  DeleteValues,
  UpdateClientValues,
} from "../../../../FormSchemes/UserScheme";
import { useSelector } from "react-redux";
import { UpdateValuesModal } from "../../../../FormSchemes/GeneralFunctions";
import { formatDateWithTime } from "../../../../utils/dateFormat";
import { DefaultParamsForRecall } from "../../../../utils/defaulStates";
import { Callers } from "../../../../hooks/Callers";
import { FilterSelectAsync } from "../../../../components/form/FilterSelect";

export const ListClientesTable = () => {
  const {
    dispatch,
    data,
    setData,
    paginate,
    setPaginate,
    selectedDay,
    setSelectedDay,
    selecteds,
    setSelecteds,
    selectAllChecked,
    setSelectAllChecked,
    isChecked,
    setIsChecked,
    stateData,
    setStateData,
    createModal,
    setCreateModal,
    updateModal,
    setUpdateModal,
    currentData,
    setCurrentData,
    requestAuthPaginate,
    TableContainer,
    Paginator,
    formatFilters,
    FilterSelect,
    Searcher,
    // RangeDate,
    TableSection,
    Actions,
    ActionSection,
    Section,
    redirect,
  } = useGeneralParams("nombres");
  const reloadMainTable = useSelector((state) => state.login.reloadMainTable);
  const [deleteModal, setDeleteModal] = useState(false);
  const lock = useSelector((state) => state.login.rol?.limitar_permisos);
  const getDataPaginate = async () => {
    await requestAuthPaginate({
      method: "get",
      url: "/users_cli/pag",
      data: null,
      queries: paginate,
      setData: setData,
      setStateData: setStateData,
      setQueries: setPaginate,
      dispatch: dispatch,
      aditionalParams: { filterBy: "nombres" },
    });
  };

  useEffect(() => {
    getDataPaginate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ...DefaultParamsForRecall(paginate),
    paginate.estado,
    paginate.rol,
    paginate.tipo_negocio,
    reloadMainTable,
  ]);

  // useEffect(() => {}, [selecteds])

  useEffect(() => {
    setSelectAllChecked(false);
    setIsChecked(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ...DefaultParamsForRecall(paginate),
    paginate.estado,
    paginate.rol,
    paginate.tipo_negocio,
  ]);

  const recall = () => {
    Callers(dispatch);
  };
  return (
    <Section>
      <ActionSection>
        <Actions
          buttons={[
            {
              icon: "add",
              label: "Crear",
              action: () => setCreateModal(true),
            },
          ]}
        />
        <Searcher
          paginate={paginate}
          setPaginate={setPaginate}
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          options={[
            {
              label: "Nombre",
              value: "nombres",
            },
            {
              label: "Código",
              value: "codigo",
            },
            {
              label: "Carnet",
              value: "ci",
            },
            {
              label: "Vendedor",
              value: "vendedor",
            },
            {
              label: "Telefono",
              value: "telefono",
            },
          ]}
          reloadTable={recall}
        />
        <div className="flex gap-2 flex-wrap">
          {/* <RangeDate
                        selectedDay={selectedDay}
                        setSelectedDay={setSelectedDay}
                        paginate={paginate}
                        setPaginate={setPaginate}
                    /> */}
          <FilterSelect
            paginate={paginate}
            setPaginate={setPaginate}
            formatFilter={formatFilters}
            name="estado"
            options={[
              {
                label: "Estado",
                value: "",
              },
              {
                label: "Activo",
                value: "activo",
              },
              {
                label: "Nuevo",
                value: "nuevo",
              },
              {
                label: "Inactivo",
                value: "inactivo",
              },
            ]}
          />
          {/* <FilterSelect
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                        name='rol'
                        options={[
                            {
                                label: 'Roles',
                                value: ''
                            },
                            {
                                label: 'Clientes',
                                value: 'cliente'
                            },
                            {
                                label: 'Empresas',
                                value: 'empresa'
                            },
                            {
                                label: 'Mayoristas',
                                value: 'mayorista'
                            },
                        ]}
                    /> */}
          <FilterSelectAsync
            paginate={paginate}
            setPaginate={setPaginate}
            formatFilter={formatFilters}
            name="tipo_negocio"
            urlApi="/nombreEstado/Tipos de negocio/subEstados"
            indexes={{
              labelIndex: "nombre",
              valueIndex: "nombre",
            }}
            defaultLabel="Tipo de negocio"
          />
          <MinimalActionButton icon="repeat" label="" action={recall} />
        </div>
      </ActionSection>
      <TableSection stateData={stateData} paginator={Paginator} data={data}>
        <TableContainer
          headers={[
            {
              label: "Negocio",
              // columns: ['tipo_negocio'],
              type: "iconImage",
              image: "tipo_negocio",
              // type: 'avatarName'
            },
            {
              label: "Nombre",
              columns: ["codigo", "nombres:apellido_paterno:apellido_materno"],
              // icon: 'fa-solid fa-user-circle text-[30px] text-red-500',
              // className: 'flex items-center',
              // tag: true,
            },
            {
              label: "Carnet",
              columns: ["ci"],
              // numberValue: true,
              // icon: 'fa-solid fa-user-circle text-[30px] text-red-500',
              // className: 'flex items-center',
              // tag: true,
            },
            {
              label: "Nit",
              columns: ["nit"],
              // numberValue: true,
              // icon: 'fa-solid fa-user-circle text-[30px] text-red-500',
              // className: 'flex items-center',
              // tag: true,
            },
            {
              label: "Telefonos",
              columns: ["telefono", "telefono2", "telefono3"],
              // numberValue: true,
              // icon: 'fa-solid fa-user-circle text-[30px] text-red-500',
              // className: 'flex items-center',
              // tag: true,
            },
            {
              label: "Zona",
              columns: ["zona"],
              // numberValue: true,
              // icon: 'fa-solid fa-user-circle text-[30px] text-red-500',
              // className: 'flex items-center',
              // tag: true,
            },
            // {
            //     label: 'Vendedores a cargo',
            //     type: 'tagList',
            //     tagList: 'vendedores',
            //     tagLabel: 'nombres'
            // },
            {
              label: "Encargados",
              type: "listData",
              tagList: "vendedores",
              tagLabel: "nombres",
            },
            // {
            //     label: 'Roles',
            //     type: 'listData',
            //     tagList: 'rols',
            //     tagLabel: 'etiqueta',
            //     iconFa: 'check',
            //     aditionalClass: 'text-green-600 dark:text-green-300 pt-0.5'
            // },
            // {
            //     label: 'Roles',
            //     type: 'tagList',
            //     tagList: 'rols',
            //     tagLabel: 'etiqueta'
            // },
            {
              label: "Estado",
              columns: ["estado"],
              tag: true,
            },
            {
              label: "Ultima compra",
              columns: ["fecha_ultima_compra"],
              transform: true,
              func: formatDateWithTime,
            },
            {
              label: "Fecha de registro",
              columns: ["createdAt"],
              transform: true,
              func: formatDateWithTime,
            },
            {
              label: "Acciones",
              actions: [
                {
                  type: "edit",
                  icon: "fa-edit",
                  action: (data) =>
                    UpdateValuesModal(data, setCurrentData, setUpdateModal),
                  lock: lock,
                },
                {
                  type: "cyan",
                  icon: "fa-share-from-square",
                  action: (data) => {
                    redirect(`users_cli/${data.id}/perfil`);
                  },
                  reference: "id",
                  redirect: true,
                },
                {
                  type: "delete",
                  icon: "fa-trash",
                  action: (data) =>
                    UpdateValuesModal(data, setCurrentData, setDeleteModal),
                  reference: "id",
                },
              ],
            },
          ]}
          data={data.data}
          doubleClickAction={(dataItem) =>
            redirect(`users_cli/${dataItem.id}/perfil`)
          }
          checkList={false}
          selecteds={selecteds}
          setSelecteds={setSelecteds}
          selectAllChecked={selectAllChecked}
          setSelectAllChecked={setSelectAllChecked}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          stateData={stateData}
        />
      </TableSection>
      {createModal && (
        <ModalForm
          setModal={setCreateModal}
          label="Registrar cliente"
          dataValues={CreateClientValues()}
          urlApi={"/userCliente"}
          method={"post"}
          call={recall}
          buttonLabel="Registrar"
        />
      )}
      {updateModal && (
        <ModalForm
          setModal={setUpdateModal}
          label="Editar Cliente"
          dataValues={UpdateClientValues(currentData)}
          urlApi={"/userCliente"}
          method={"put"}
          call={recall}
          buttonLabel="Registrar"
        />
      )}
      {deleteModal && (
        <ModalForm
          setModal={setDeleteModal}
          label="Eliminar usuario"
          dataValues={DeleteValues(currentData)}
          urlApi={`/user/${currentData.id}`}
          method={"delete"}
          call={recall}
          buttonLabel="Registrar"
        />
      )}
    </Section>
  );
};
